(function (root) {
  var ALLOWED_EVENTS = [
    'stone_list_load',
    'stone_filter_change',
    'stone_filter_reset',
    'stone_pagination',
    'stone_view',
    'stone_selected',
    'setting_list_load',
    'setting_filter_change',
    'setting_view',
    'setting_selected',
    'review_page',
    'add_to_cart'
  ];

  var UUID_V4_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var RC_ATC_TTL_MS = 60000;
  var RESET_PENDING_TTL_MS = 1200;

  function uuidv4(runtime) {
    runtime = runtime || root;
    if (runtime.crypto && typeof runtime.crypto.randomUUID === 'function') {
      return runtime.crypto.randomUUID();
    }
    if (runtime.crypto && typeof runtime.crypto.getRandomValues === 'function') {
      var bytes = new Uint8Array(16);
      runtime.crypto.getRandomValues(bytes);
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;
      var hex = Array.prototype.map.call(bytes, function (value) {
        return value.toString(16).padStart(2, '0');
      }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' +
        hex.slice(16, 20) + '-' + hex.slice(20);
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  function readFlowToken(doc) {
    var match = String((doc && doc.cookie) || '').match(/(?:^|;\s*)gs_flow_token=([^;]+)/);
    var token = match && decodeURIComponent(match[1]);
    return token && UUID_V4_RE.test(token) ? token : null;
  }

  function ensureFlowToken(runtime) {
    runtime = runtime || root;
    var token = readFlowToken(runtime.document);
    if (token) return token;
    token = uuidv4(runtime);
    var cookie = 'gs_flow_token=' + encodeURIComponent(token) + '; Max-Age=86400; path=/; SameSite=Lax';
    if (runtime.location && runtime.location.protocol === 'https:') cookie += '; Secure';
    runtime.document.cookie = cookie;
    return token;
  }

  function requestBodyToObject(input, init) {
    try {
      var body = init && init.body !== undefined ? init.body : input && input.body;
      if (!body) return {};
      if (typeof body === 'string') {
        try {
          var json = JSON.parse(body);
          return json && typeof json === 'object' ? json : {};
        } catch (ignore) {
          var params = new URLSearchParams(body);
          var stringOut = {};
          params.forEach(function (value, key) { stringOut[key] = value; });
          return stringOut;
        }
      }
      var out = {};
      if (typeof body.forEach === 'function') {
        body.forEach(function (value, key) {
          out[key] = typeof value === 'string' ? value : String(value);
        });
      }
      return out;
    } catch (ignoreBody) {
      return {};
    }
  }

  function searchParamsObject(search) {
    var out = {};
    try {
      new URLSearchParams(search || '').forEach(function (value, key) {
        if (Object.prototype.hasOwnProperty.call(out, key)) {
          out[key] = Array.isArray(out[key]) ? out[key].concat(value) : [out[key], value];
        } else {
          out[key] = value;
        }
      });
    } catch (ignore) {}
    return out;
  }

  // Shopify markets prefix routes with a language tag, optionally with a region
  // or script subtag (/en, /en-ca, /pt-br, /zh-cn, /zh-Hans). Only that shape is
  // stripped so real first segments such as /collections or /all-custom survive.
  var LOCALE_PREFIX_RE = /^\/[a-z]{2}(?:-(?:[a-z]{2}|[a-z]{4}))?(?=\/|$)/i;

  function canonicalPath(path) {
    path = String(path || '');
    return path.replace(LOCALE_PREFIX_RE, '') || '/';
  }

  function isDiamondPdpPath(path) {
    return canonicalPath(path) === '/products/diamond';
  }

  function isDiamondCollectionPath(path) {
    path = canonicalPath(path);
    return path === '/collections/diamonds' ||
      path.indexOf('/collections/diamonds/') === 0 ||
      path.indexOf('/collections/vdb-diamond-collection') === 0;
  }

  function flowFromContext(search, ctx) {
    var params = searchParamsObject(search);
    if (params.diamondFirstFlowRingSelected === 'true' || params.is_diamond_selected === 'true') return 'diamond_first';
    var path = (ctx && ctx.path) || '';
    if (isDiamondPdpPath(path) || isDiamondCollectionPath(path)) return 'diamond_first';
    if (params.is_setting_selected === 'true' || (ctx && ctx.isSettingPdp)) return 'setting_first';
    if (ctx && ctx.hasStoneList) return 'diamond_first';
    if (ctx && ctx.hasVdbMain) return 'setting_first';
    return 'unknown';
  }

  function diamondTypeFromContext(search, activeType) {
    var type = searchParamsObject(search).type || activeType || null;
    if (type === 'Diamond' || type === 'Lab_grown_Diamond') return type;
    if (type === 'Natural' || type === 'natural') return 'Diamond';
    if (type === 'Lab Grown' || type === 'labGrown') return 'Lab_grown_Diamond';
    return null;
  }

  function diamondTypeFromRuntime(runtime) {
    var activeType = null;
    var active = safeQuery(runtime, '.vdb-gs-tab-wrap li a.active');
    try {
      activeType = active && active.dataset && active.dataset.type;
    } catch (ignore) {}
    return diamondTypeFromContext((runtime.location && runtime.location.search) || '', activeType);
  }

  function filtersFromSearch(search) {
    return searchParamsObject(search);
  }

  function createDedupe(storage) {
    var memory = new Set();
    var lastFilter = { snapshot: null, at: 0 };
    return {
      once: function (eventType, identity) {
        var key = 'gs_evt:' + eventType + ':' + identity;
        if (memory.has(key)) return false;
        try {
          if (storage && storage.getItem(key)) {
            memory.add(key);
            return false;
          }
        } catch (ignoreGet) {}
        memory.add(key);
        try {
          if (storage) storage.setItem(key, '1');
        } catch (ignoreSet) {}
        return true;
      },
      rapidFilter: function (snapshot, now) {
        if (lastFilter.snapshot === snapshot && now - lastFilter.at < 400) return false;
        lastFilter.snapshot = snapshot;
        lastFilter.at = now;
        return true;
      }
    };
  }

  function safeQuery(runtime, selector) {
    try {
      return runtime.document && runtime.document.querySelector(selector);
    } catch (ignore) {
      return null;
    }
  }

  function runtimePageType(runtime) {
    var path = (runtime.location && runtime.location.pathname) || '';
    var review = safeQuery(runtime, '[data-selected-diamond-html]');
    var liveStoneList = safeQuery(runtime, '#vdb-gs-data-body-data');
    var hasLiveStoneList = reviewHasContent(liveStoneList, runtime);
    return pageTypeFromContext({
      path: path,
      hasReview: reviewHasContent(review, runtime),
      hasLiveStoneList: hasLiveStoneList,
      hasRingCollection: !!safeQuery(runtime, '#vdb-ring-collection'),
      isSettingPdp: !isDiamondPdpPath(path) && !!safeQuery(runtime, '.button--select-your-diamond')
    });
  }

  function normalizedCustomerScalar(value, maxLength) {
    var type = typeof value;
    if (type !== 'string' && type !== 'number' && type !== 'boolean') return null;
    if (type === 'number' && !isFinite(value)) return null;
    var normalized = String(value).trim();
    if (!normalized) return null;
    return Array.from(normalized).slice(0, maxLength).join('');
  }

  function customerFromContext(runtime, configured) {
    if (configured && typeof configured === 'object') {
      var loggedIn = configured.logged_in === true;
      var configuredCustomer = { logged_in: loggedIn };
      if (!loggedIn) return configuredCustomer;
      [
        ['id', 32],
        ['email', 254],
        ['name', 255]
      ].forEach(function (field) {
        var normalized = normalizedCustomerScalar(configured[field[0]], field[1]);
        if (normalized !== null) configuredCustomer[field[0]] = normalized;
      });
      return configuredCustomer;
    }
    try {
      var pxu = runtime.PXUTheme || {};
      var hasIdentity = !!(pxu.customerEmail || (pxu.customer && pxu.customer.email) ||
        (pxu.translation && pxu.translation.customer_email));
      return {
        logged_in: !!(hasIdentity || pxu.customer || pxu.logged_in || pxu.loggedIn ||
          (pxu.theme_settings && (pxu.theme_settings.userLoggedIn || pxu.theme_settings.customer_logged_in)))
      };
    } catch (ignore) {
      return { logged_in: false };
    }
  }

  function withoutIp(value) {
    if (Array.isArray(value)) return value.map(withoutIp);
    if (!value || typeof value !== 'object') return value;
    var out = {};
    Object.keys(value).forEach(function (key) {
      if (key !== 'ip') out[key] = withoutIp(value[key]);
    });
    return out;
  }

  function debugWarn(runtime, config, error) {
    try {
      if (config.debug && runtime.console && typeof runtime.console.warn === 'function') {
        runtime.console.warn('[GS journey tracking]', error);
      }
    } catch (ignore) {}
  }

  function createTracker(runtime, config) {
    runtime = runtime || root;
    config = config || runtime.GS_JOURNEY_TRACKING_CONFIG || {};
    var flowToken = ensureFlowToken(runtime);

    function track(eventType, jsonData, error) {
      if (ALLOWED_EVENTS.indexOf(eventType) === -1 || !config.endpoint) return false;
      try {
        var search = (runtime.location && runtime.location.search) || '';
        var shop = config.shop || (runtime.Shopify && runtime.Shopify.shop) || '';
        if (!shop) return false;
        var path = (runtime.location && runtime.location.pathname) || '';
        var isSettingPdp = !isDiamondPdpPath(path) && !!safeQuery(runtime, '.button--select-your-diamond');
        var contextual = {
          flow: flowFromContext(search, {
            path: path,
            hasStoneList: reviewHasContent(safeQuery(runtime, '#vdb-gs-data-body-data'), runtime),
            isSettingPdp: isSettingPdp,
            hasVdbMain: !!safeQuery(runtime, '.vdb_gs_main')
          }),
          diamond_type: diamondTypeFromRuntime(runtime)
        };
        Object.keys(jsonData || {}).forEach(function (key) { contextual[key] = jsonData[key]; });
        var payload = {
          shop: shop,
          flow_token: flowToken,
          url: (runtime.location && runtime.location.href) || '',
          customer_json: customerFromContext(runtime, config.customer),
          page_type: runtimePageType(runtime),
          event_type: eventType,
          json_data: withoutIp(buildEnvelope({ extra: contextual })),
          error: error ? String(error.message || error) : null
        };
        var serialized = JSON.stringify(payload);
        var sent = false;
        if (runtime.navigator && typeof runtime.navigator.sendBeacon === 'function' && runtime.Blob) {
          try {
            // text/plain keeps the beacon a CORS-simple request; the endpoint
            // parses the raw body as JSON regardless of declared type.
            sent = runtime.navigator.sendBeacon(
              config.endpoint,
              new runtime.Blob([serialized], { type: 'text/plain;charset=UTF-8' })
            );
          } catch (beaconError) {
            debugWarn(runtime, config, beaconError);
          }
        }
        if (!sent && typeof runtime.fetch === 'function') {
          try {
            var pending = runtime.fetch(config.endpoint, {
              method: 'POST',
              mode: 'cors',
              keepalive: true,
              headers: { 'Content-Type': 'application/json' },
              body: serialized
            });
            if (pending && typeof pending.catch === 'function') {
              pending.catch(function (fetchError) { debugWarn(runtime, config, fetchError); });
            }
          } catch (fetchError) {
            debugWarn(runtime, config, fetchError);
          }
        }
        return true;
      } catch (trackError) {
        debugWarn(runtime, config, trackError);
        return false;
      }
    }

    return { track: track, flowToken: flowToken };
  }

  function requestUrl(input) {
    try {
      return typeof input === 'string' ? input : (input && input.url) || String(input || '');
    } catch (ignore) {
      return '';
    }
  }

  function responseError(response, parsed) {
    if (parsed && (parsed.error || parsed.message || parsed.description)) {
      return String(parsed.error || parsed.message || parsed.description);
    }
    return 'HTTP ' + ((response && response.status) || 0);
  }

  function parseResponseClone(response) {
    try {
      var clone = response.clone();
      return clone.text().then(function (text) {
        try { return JSON.parse(text); } catch (ignoreJson) { return text; }
      });
    } catch (ignoreClone) {
      return Promise.resolve(null);
    }
  }

  function listPayload(request, parsed) {
    var body = parsed && parsed.main_data && parsed.main_data.response && parsed.main_data.response.body;
    var diamonds = (body && body.diamonds) || [];
    var filters = {};
    Object.keys(request || {}).forEach(function (key) {
      if (['action', 'shop', 'page_number'].indexOf(key) === -1) filters[key] = request[key];
    });
    return {
      filters: filters,
      pagination: { page_number: Number(request.page_number || (parsed && parsed.current_page) || 1) },
      list: {
        total_count: body && body.total_diamonds_found !== undefined ? body.total_diamonds_found : null,
        result_count: Array.isArray(diamonds) ? diamonds.length : null
      }
    };
  }

  function cartPayload(request) {
    var items = (request && request.items) || [];
    var variants = [];
    var groupId = null;
    items.forEach(function (item) {
      if (item && item.id !== undefined) variants.push(item.id);
      if (!groupId && item && item.properties) groupId = item.properties._groupId || null;
    });
    return { cart: { group_id: groupId, variant_ids: variants } };
  }

  function mergeCartPayload(first, second) {
    first = (first && first.cart) || { group_id: null, variant_ids: [] };
    second = (second && second.cart) || { group_id: null, variant_ids: [] };
    var variants = (first.variant_ids || []).concat(second.variant_ids || []).filter(function (id, index, all) {
      return all.indexOf(id) === index;
    });
    return { cart: { group_id: second.group_id || first.group_id || null, variant_ids: variants } };
  }

  function stoneFromParsed(parsed, request) {
    var stone = Array.isArray(parsed) ? parsed[0] : parsed;
    stone = stone && typeof stone === 'object' ? stone : {};
    return {
      stock_num: stone.stock_num || request.stock_num,
      stone_reference_id: stone.vendor_id || stone.stone_reference_id || request.vendor_id,
      shape: stone.shape,
      type: request.type
    };
  }

  // The variant created for the selected stone is only known from createProduct,
  // but it belongs to the add_to_cart event that closes the journey.
  function atcPayload(state, cart, groupId) {
    var payload = { cart: (cart && cart.cart) || { group_id: groupId || null, variant_ids: [] } };
    var varId = state && state.lastVarId;
    if (varId !== undefined && varId !== null && varId !== '') payload.stone = { var_id: varId };
    return payload;
  }

  function finishRcAtc(runtime, state, pendingAtc, onEvent, error) {
    state.pendingRcAtc = null;
    if (pendingAtc.expiryTimer !== undefined && runtime && typeof runtime.clearTimeout === 'function') {
      runtime.clearTimeout(pendingAtc.expiryTimer);
    }
    if (pendingAtc.expiresAt !== undefined && Date.now() >= pendingAtc.expiresAt) return;
    onEvent('add_to_cart', atcPayload(state, pendingAtc.cart, pendingAtc.groupId), error || null);
    state.lastVarId = null;
  }

  function handleNetworkResult(runtime, url, request, response, parsed, onEvent, state) {
    if (shouldSkipUrl(url)) return;
    var ok = !!(response && response.ok);
    if (url.indexOf('frontend.php') !== -1) {
      if (request.action === 'getAllFilterProducts') {
        onEvent('stone_list_load', listPayload(request, parsed), ok ? null : responseError(response, parsed));
      } else if (request.action === 'getProduct' && runtime.location && isDiamondPdpPath(runtime.location.pathname)) {
        onEvent('stone_view', { stone: stoneFromParsed(parsed, request) }, ok ? null : responseError(response, parsed));
      } else if (request.action === 'createProduct') {
        if (ok && parsed && String(parsed.isSuccess) === '1') {
          state.lastVarId = parsed.var_id;
        } else if (state.pendingRcAtc) {
          finishRcAtc(runtime, state, state.pendingRcAtc, onEvent, responseError(response, parsed));
        }
      }
    } else if (url.indexOf('cart/add.js') !== -1 && state.pendingRcAtc) {
      var pendingAtc = state.pendingRcAtc;
      if (Date.now() >= pendingAtc.expiresAt) {
        state.pendingRcAtc = null;
        return;
      }
      var currentCart = cartPayload(request);
      var groupId = currentCart.cart.group_id;
      if (pendingAtc.groupId && groupId && pendingAtc.groupId !== groupId) return;
      if (!pendingAtc.groupId && groupId) pendingAtc.groupId = groupId;
      pendingAtc.cart = mergeCartPayload(pendingAtc.cart, currentCart);
      if (!ok) {
        pendingAtc.lastError = responseError(response, parsed);
        return;
      }
      pendingAtc.lastError = null;
      if (pendingAtc.expectsPair && pendingAtc.cart.cart.variant_ids.length < 2) return;
      finishRcAtc(runtime, state, pendingAtc, onEvent, null);
    }
  }

  function handleNetworkFailure(runtime, url, request, error, onEvent, state) {
    if (shouldSkipUrl(url)) return;
    var message = String((error && error.message) || error || 'Network error');
    if (error && error.name === 'AbortError' && url.indexOf('frontend.php') !== -1 &&
      request.action === 'getAllFilterProducts') return;
    if (url.indexOf('frontend.php') !== -1 && request.action === 'getAllFilterProducts') {
      onEvent('stone_list_load', listPayload(request, null), message);
    } else if (url.indexOf('frontend.php') !== -1 && request.action === 'getProduct' &&
      runtime.location && isDiamondPdpPath(runtime.location.pathname)) {
      onEvent('stone_view', { stone: stoneFromParsed(null, request) }, message);
    } else if (url.indexOf('frontend.php') !== -1 && request.action === 'createProduct' && state.pendingRcAtc) {
      finishRcAtc(runtime, state, state.pendingRcAtc, onEvent, message);
    } else if (url.indexOf('cart/add.js') !== -1 && state.pendingRcAtc) {
      if (Date.now() >= state.pendingRcAtc.expiresAt) {
        state.pendingRcAtc = null;
        return;
      }
      var failedCart = cartPayload(request);
      var failedGroup = failedCart.cart.group_id;
      if (state.pendingRcAtc.groupId && failedGroup && state.pendingRcAtc.groupId !== failedGroup) return;
      if (!state.pendingRcAtc.groupId && failedGroup) state.pendingRcAtc.groupId = failedGroup;
      state.pendingRcAtc.cart = mergeCartPayload(state.pendingRcAtc.cart, failedCart);
      state.pendingRcAtc.lastError = message;
    }
  }

  function isRelevantNetworkUrl(url, state) {
    if (shouldSkipUrl(url)) return false;
    if (url.indexOf('frontend.php') !== -1) return true;
    if (url.indexOf('cart/add.js') === -1 || !(state && state.pendingRcAtc)) return false;
    if (Date.now() >= state.pendingRcAtc.expiresAt) {
      state.pendingRcAtc = null;
      return false;
    }
    return true;
  }

  function installFetchInterceptor(runtime, onEvent, state) {
    if (!runtime || typeof runtime.fetch !== 'function' || runtime.fetch.__gsJourneyWrapped) return runtime && runtime.fetch;
    var original = runtime.fetch;
    function wrappedFetch() {
      var thisArg = this;
      var args = Array.prototype.slice.call(arguments);
      var url = requestUrl(args[0]);
      var relevant = isRelevantNetworkUrl(url, state);
      var request = relevant ? requestBodyToObject(args[0], args[1] || {}) : {};
      var result;
      try {
        result = original.apply(thisArg, args);
      } catch (error) {
        handleNetworkFailure(runtime, url, request, error, onEvent, state);
        throw error;
      }
      if (!relevant) return result;
      return Promise.resolve(result).then(function (response) {
        return parseResponseClone(response).then(function (parsed) {
          handleNetworkResult(runtime, url, request, response, parsed, onEvent, state);
          return response;
        }, function () {
          handleNetworkResult(runtime, url, request, response, null, onEvent, state);
          return response;
        });
      }, function (error) {
        handleNetworkFailure(runtime, url, request, error, onEvent, state);
        throw error;
      });
    }
    wrappedFetch.__gsJourneyWrapped = true;
    wrappedFetch.__gsJourneyOriginal = original;
    runtime.fetch = wrappedFetch;
    return wrappedFetch;
  }

  function installXhrInterceptor(runtime, onEvent, state) {
    var Xhr = runtime && runtime.XMLHttpRequest;
    if (!Xhr || !Xhr.prototype || Xhr.prototype.__gsJourneyWrapped) return;
    var proto = Xhr.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;
    proto.open = function () {
      this.__gsJourneyUrl = requestUrl(arguments[1]);
      return originalOpen.apply(this, arguments);
    };
    proto.send = function (body) {
      var xhr = this;
      var request = requestBodyToObject(null, { body: body });
      if (!isRelevantNetworkUrl(xhr.__gsJourneyUrl || '', state)) return originalSend.apply(this, arguments);
      function complete() {
        var parsed = null;
        try { parsed = JSON.parse(xhr.responseText); } catch (ignoreJson) {}
        handleNetworkResult(
          runtime,
          xhr.__gsJourneyUrl || '',
          request,
          { ok: xhr.status >= 200 && xhr.status < 300, status: xhr.status },
          parsed,
          onEvent,
          state
        );
      }
      function fail() {
        var error = new Error('XHR network error');
        error.name = 'NetworkError';
        handleNetworkFailure(runtime, xhr.__gsJourneyUrl || '', request, error, onEvent, state);
      }
      function abort() {
        if (request.action === 'getAllFilterProducts') return;
        var error = new Error('XHR aborted');
        error.name = 'AbortError';
        handleNetworkFailure(runtime, xhr.__gsJourneyUrl || '', request, error, onEvent, state);
      }
      try {
        xhr.addEventListener('load', complete);
        xhr.addEventListener('error', fail);
        xhr.addEventListener('abort', abort);
        xhr.addEventListener('timeout', fail);
      } catch (ignoreListener) {}
      return originalSend.apply(this, arguments);
    };
    proto.__gsJourneyWrapped = true;
  }

  function filterSnapshotFromDiamond(diamond) {
    var config = (diamond && diamond.config) || {};
    var filters = {};
    Object.keys(config).forEach(function (key) {
      if (key !== 'page_number' && config[key] !== undefined && config[key] !== '') filters[key] = config[key];
    });
    return filters;
  }

  function diffFilterSnapshots(previous, current) {
    previous = previous || {};
    current = current || {};
    var changed = {};
    Object.keys(previous).concat(Object.keys(current)).forEach(function (key) {
      if (Object.prototype.hasOwnProperty.call(changed, key)) return;
      var from = Object.prototype.hasOwnProperty.call(previous, key) ? previous[key] : null;
      var to = Object.prototype.hasOwnProperty.call(current, key) ? current[key] : null;
      if (stableStringify(from) !== stableStringify(to)) changed[key] = { from: from, to: to };
    });
    return changed;
  }

  function wrapDiamondMethods(diamond, onEvent, state) {
    if (!diamond || typeof diamond !== 'object') return false;
    if (state.diamondFilterBaseline === undefined) {
      state.diamondFilterBaseline = filterSnapshotFromDiamond(diamond);
    }
    var before = diamond.callBeforeLGDiamond;
    if (typeof before === 'function' && !before.__gsJourneyWrapped) {
      var wrappedBefore = function () {
        var filters = filterSnapshotFromDiamond(this);
        if (state.resetPending && Date.now() < state.resetExpiresAt) {
          state.resetPending = false;
          state.resetExpiresAt = 0;
          state.diamondFilterBaseline = filters;
        } else {
          state.resetPending = false;
          state.resetExpiresAt = 0;
          var changed = diffFilterSnapshots(state.diamondFilterBaseline, filters);
          state.diamondFilterBaseline = filters;
          var filterData = { filters: filters };
          if (Object.keys(changed).length) filterData.changed = changed;
          onEvent('stone_filter_change', filterData);
        }
        return before.apply(this, arguments);
      };
      wrappedBefore.__gsJourneyWrapped = true;
      diamond.callBeforeLGDiamond = wrappedBefore;
    }
    var review = diamond.initSelectDiamondProduct;
    if (typeof review === 'function' && !review.__gsJourneyWrapped) {
      var wrappedReview = function () {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        var stone = args[0] || {};
        var result = review.apply(self, args);
        function completeReview(value) {
          var setting = state.currentSetting || {};
          var stoneData = {
            stock_num: stone.stock_num,
            stone_reference_id: stone.vendor_id || stone.stone_reference_id,
            shape: stone.shape,
            type: stone.type
          };
          var identity = (stoneData.stock_num || stone.id || '') + ':' +
            (setting.variant_id || setting.product_id || setting.handle || '');
          if (state.pendingStoneSelection) {
            onEvent('stone_selected', { stone: state.pendingStoneSelection.stone || stoneData });
            state.pendingStoneSelection = null;
          }
          onEvent('review_page', { stone: stoneData, setting: setting }, null, identity);
          return value;
        }
        return result && typeof result.then === 'function' ? result.then(completeReview) : completeReview(result);
      };
      wrappedReview.__gsJourneyWrapped = true;
      diamond.initSelectDiamondProduct = wrappedReview;
    }
    diamond.__gsJourneyWrapped = true;
    return true;
  }

  function parseStoneText(text) {
    try {
      var parsed = JSON.parse(text || '');
      return {
        stock_num: parsed.stock_num,
        stone_reference_id: parsed.vendor_id || parsed.stone_reference_id,
        shape: parsed.shape,
        type: parsed.type,
        id: parsed.id
      };
    } catch (ignore) {
      return {};
    }
  }

  function stoneForElement(runtime, element) {
    try {
      var id = element && element.dataset && (element.dataset.selectItem || element.dataset.selectedDiamondId);
      if (id && runtime.document && runtime.document.getElementById) {
        var dataElement = runtime.document.getElementById(id);
        return parseStoneText(dataElement && (dataElement.textContent || dataElement.innerHTML));
      }
      var row = element && element.closest && element.closest('.vdb_gd_data_tr');
      var textarea = row && row.querySelector && row.querySelector('textarea[id^="pro-data-"]');
      return parseStoneText(textarea && (textarea.textContent || textarea.value || textarea.innerHTML));
    } catch (ignore) {
      return {};
    }
  }

  function closest(target, selector) {
    try { return target && target.closest ? target.closest(selector) : null; } catch (ignore) { return null; }
  }

  function settingFromElement(element) {
    if (!element) return {};
    var dataset = element.dataset || {};
    var href = (element.getAttribute && element.getAttribute('href')) || element.href || '';
    var setting = {
      product_id: dataset.productId,
      handle: dataset.handle,
      variant_id: dataset.variantId,
      ring_size: dataset.ringSize
    };
    try {
      var url = new URL(href, 'https://example.invalid');
      setting.handle = setting.handle || (url.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
      setting.variant_id = setting.variant_id || url.searchParams.get('variant') || undefined;
      setting.ring_size = setting.ring_size || url.searchParams.get('ring_size') || undefined;
    } catch (ignoreUrl) {}
    return setting;
  }

  function settingFromRuntime(runtime) {
    var setting = settingFromLocation(runtime);
    try {
      var variantSelection = safeQuery(runtime, 'variant-selection');
      var ringSize = safeQuery(runtime, '#data-variant-option-ring-size');
      setting.variant_id = variantSelection && variantSelection.variant !== undefined ?
        variantSelection.variant : setting.variant_id;
      setting.ring_size = ringSize && ringSize.value ? ringSize.value : setting.ring_size;
    } catch (ignore) {}
    return setting;
  }

  function isValidSettingVariant(variant) {
    if (variant === undefined || variant === null || variant === '') return false;
    var normalized = String(variant).toLowerCase();
    return normalized !== 'unavailable' && normalized !== 'not-selected';
  }

  function settingConfirmationLabel(element) {
    var parts = [];
    try {
      parts.push(element.textContent || element.innerText || '');
      parts.push(element.value || '');
      if (element.getAttribute) parts.push(element.getAttribute('aria-label') || '');
      var visibleChild = element.querySelector && element.querySelector('.nice-frame, .text');
      if (visibleChild) parts.push(visibleChild.textContent || visibleChild.innerText || '');
    } catch (ignore) {}
    return parts.join(' ').trim();
  }

  function isStoneResetContext(runtime, reset) {
    if (closest(reset, '.vdb_gs_main')) return true;
    var path = canonicalPath((runtime.location && runtime.location.pathname) || '');
    var isSettingList = path.indexOf('/collections/all-custom') === 0 ||
      /\/collections\/(.*engagement|.*-cut-engagement-ring)/.test(path);
    if (isSettingList) return false;
    return visibleElement(safeQuery(runtime, '#vdb-gs-data-body-data'), runtime);
  }

  function handleDelegatedClick(runtime, event, onEvent, state, dedupe) {
    var target = event && event.target;
    var search = (runtime.location && runtime.location.search) || '';
    var reset = closest(target, '.vdb-gs-clear-all-filters');
    if (reset) {
      var isStoneReset = isStoneResetContext(runtime, reset);
      if (event.isTrusted === false) {
        if (isStoneReset) {
          state.resetPending = true;
          state.resetExpiresAt = Date.now() + RESET_PENDING_TTL_MS;
        }
        return;
      }
      if (!isStoneReset) {
        markSettingFilterEmitted(state);
        onEvent('setting_filter_change', { filters: {}, changed: { reset: true } });
        return;
      }
      state.resetPending = true;
      state.resetExpiresAt = Date.now() + RESET_PENDING_TTL_MS;
      onEvent('stone_filter_reset', { filters: filtersFromSearch(search) });
      return;
    }
    var pagination = closest(target, '.pagination-button__load-number');
    if (pagination) {
      var params = filtersFromSearch(search);
      var livePage = runtime.NATURAL_LB_GROWN_DIAMOND &&
        runtime.NATURAL_LB_GROWN_DIAMOND.config &&
        runtime.NATURAL_LB_GROWN_DIAMOND.config.page_number;
      onEvent('stone_pagination', {
        pagination: {
          from_page: Number(livePage || params.page_number || 1),
          to_page: Number((pagination.dataset && pagination.dataset.current_page) || pagination.textContent || 1)
        }
      });
      return;
    }
    var select = closest(target, '.vdb_gs-outline-btn');
    if (select) {
      var selectedData = { stone: stoneForElement(runtime, select) };
      if (safeQuery(runtime, '#modal-breadcrumbs')) {
        state.pendingStoneSelection = selectedData;
      } else {
        onEvent('stone_selected', selectedData);
      }
      return;
    }
    var atc = closest(target, '.button--add-to-cart');
    if (atc) {
      var selectedProduct = safeQuery(runtime, '[data-selected-diamond-product]');
      var hasSelectedProduct = !!(selectedProduct &&
        String(selectedProduct.value || selectedProduct.textContent || selectedProduct.innerHTML || '').trim());
      if (!((atc.dataset && atc.dataset.selectedDiamondId) || hasSelectedProduct)) return;
      var now = Date.now();
      var pendingAtc = {
        at: now,
        expiresAt: now + RC_ATC_TTL_MS,
        stone: stoneForElement(runtime, atc),
        expectsPair: !!safeQuery(runtime, 'variant-selection')
      };
      if (typeof runtime.setTimeout === 'function') {
        pendingAtc.expiryTimer = runtime.setTimeout(function () {
          if (state.pendingRcAtc !== pendingAtc) return;
          if (pendingAtc.lastError) {
            onEvent('add_to_cart', atcPayload(state, pendingAtc.cart, pendingAtc.groupId), pendingAtc.lastError);
          }
          state.pendingRcAtc = null;
          state.lastVarId = null;
        }, RC_ATC_TTL_MS);
      }
      state.pendingRcAtc = pendingAtc;
      return;
    }
    var settingConfirmation = closest(target, '.button--select-your-diamond');
    if (settingConfirmation && runtime.location && !isDiamondPdpPath(runtime.location.pathname)) {
      var variantSelection = safeQuery(runtime, 'variant-selection');
      var liveVariant = variantSelection && variantSelection.variant;
      var reviewContent = safeQuery(runtime, '[data-selected-diamond-html]');
      if (!isValidSettingVariant(liveVariant) ||
        /\bview(?:\s+ring(?:\s+details)?)?\b/i.test(settingConfirmationLabel(settingConfirmation)) ||
        reviewHasContent(reviewContent, runtime)) return;
      var confirmedSetting = settingFromRuntime(runtime);
      confirmedSetting.variant_id = liveVariant;
      state.currentSetting = confirmedSetting;
      onEvent('setting_selected', { setting: confirmedSetting });
      return;
    }
    var settingFilter = closest(target, '.vdb_gs-setting-style-item, .vdb_gs-band-metal-item');
    if (settingFilter) {
      var data = settingFilter.dataset || {};
      var changed = data.settingStyle !== undefined ?
        { setting_style: data.settingStyle } : { band_metal: data.bandMetal };
      markSettingFilterEmitted(state);
      onEvent('setting_filter_change', { filters: filtersFromSearch(search), changed: changed });
      return;
    }
    var rowCell = closest(target, '.vdb_gs-td');
    if (rowCell) {
      var rowStone = stoneForElement(runtime, rowCell);
      onEvent('stone_view', { stone: rowStone });
      return;
    }
    var link = closest(target, 'a[href]');
    if (link) {
      var href = (link.getAttribute && link.getAttribute('href')) || link.href || '';
      if (/[?&](?:is_diamond_selected|diamondFirstFlowRingSelected)=true(?:&|$)/.test(href)) {
        var setting = settingFromElement(link);
        state.currentSetting = setting;
        onEvent('setting_selected', { setting: setting });
      }
    }
  }

  function stableStringify(value) {
    if (Array.isArray(value)) return '[' + value.map(stableStringify).join(',') + ']';
    if (value && typeof value === 'object') {
      return '{' + Object.keys(value).sort().map(function (key) {
        return JSON.stringify(key) + ':' + stableStringify(value[key]);
      }).join(',') + '}';
    }
    return JSON.stringify(value);
  }

  function eventIdentity(eventType, data, pageNonce) {
    data = data || {};
    var stone = data.stone || {};
    var setting = data.setting || {};
    var cart = data.cart || {};
    if (eventType === 'stone_list_load') {
      return stableStringify({ filters: data.filters || {}, pagination: data.pagination || {} });
    }
    if (eventType === 'stone_view') return pageNonce + ':' + (stone.stock_num || stone.stone_reference_id || stone.id);
    if (eventType === 'stone_selected') return stone.var_id || stone.stock_num || stone.stone_reference_id;
    if (eventType === 'setting_list_load') return stableStringify({ filters: data.filters || {}, list: data.list || {} });
    if (eventType === 'setting_view') return pageNonce + ':' + (setting.product_id || setting.handle);
    if (eventType === 'setting_selected') return setting.variant_id || setting.product_id || setting.handle;
    if (eventType === 'review_page') {
      return (stone.stock_num || stone.stone_reference_id || '') + ':' +
        (setting.variant_id || setting.product_id || setting.handle || '');
    }
    if (eventType === 'add_to_cart') return cart.group_id || stableStringify(cart.variant_ids || []);
    return null;
  }

  function createEventSink(tracker, dedupe, nowFn, pageNonce) {
    nowFn = nowFn || Date.now;
    pageNonce = pageNonce || 'page';
    var onceEvents = {
      stone_list_load: true,
      stone_view: true,
      stone_selected: true,
      setting_list_load: true,
      setting_view: true,
      setting_selected: true,
      review_page: true,
      add_to_cart: true
    };
    return function (eventType, data, error, suppliedIdentity) {
      try {
        if (eventType === 'stone_filter_change') {
          var snapshot = stableStringify((data && data.filters) || {});
          if (!dedupe.rapidFilter(snapshot, nowFn())) return false;
        }
        if (!error && onceEvents[eventType]) {
          var identity = suppliedIdentity || eventIdentity(eventType, data, pageNonce);
          if (identity && !dedupe.once(eventType, identity)) return false;
        }
        tracker.track(eventType, data || {}, error);
        return true;
      } catch (ignore) {
        return false;
      }
    };
  }

  function settingFromLocation(runtime) {
    var path = (runtime.location && runtime.location.pathname) || '';
    var params = filtersFromSearch((runtime.location && runtime.location.search) || '');
    return {
      handle: (path.match(/\/products\/([^/?#]+)/) || [])[1],
      variant_id: params.variant,
      ring_size: params.ring_size
    };
  }

  function visibleElement(element, runtime) {
    if (!element) return false;
    try {
      var current = element;
      var depth = 0;
      while (current && depth < 100) {
        if (current.hidden || (current.style && current.style.display === 'none')) return false;
        if (runtime && typeof runtime.getComputedStyle === 'function') {
          try {
            var computed = runtime.getComputedStyle(current);
            if (computed && computed.display === 'none') return false;
          } catch (ignoreComputed) {}
        }
        current = current.parentElement;
        depth++;
      }
      return true;
    } catch (ignore) {
      return true;
    }
  }

  function reviewHasContent(element, runtime) {
    if (!visibleElement(element, runtime)) return false;
    try {
      return !!((element.children && element.children.length) ||
        String(element.innerHTML || element.textContent || '').trim());
    } catch (ignore) {
      return false;
    }
  }

  function emitInitialPageEvents(runtime, onEvent) {
    var path = canonicalPath((runtime.location && runtime.location.pathname) || '');
    var ring = safeQuery(runtime, '#vdb-ring-collection');
    var grid = safeQuery(runtime, '.collection-matrix');
    var isSettingList = path.indexOf('/collections/all-custom') === 0 ||
      /\/collections\/.*engagement/.test(path) ||
      /\/collections\/.*-cut-engagement-ring/.test(path);
    var listContainer = ring && ((ring.children && ring.children.length) || ring.innerHTML) ? ring : (isSettingList ? grid : null);
    if (listContainer) {
      var count = null;
      try { count = listContainer.querySelectorAll('.product__grid-item, .product-wrap').length; } catch (ignoreCount) {}
      onEvent('setting_list_load', {
        filters: filtersFromSearch((runtime.location && runtime.location.search) || ''),
        list: { result_count: count }
      });
    }
    if (!isDiamondPdpPath(path) && safeQuery(runtime, '.button--select-your-diamond')) {
      onEvent('setting_view', { setting: settingFromLocation(runtime) });
    }
    var review = safeQuery(runtime, '[data-selected-diamond-html]');
    var reviewStep = safeQuery(runtime, '.breadcrumb-step:nth-child(3).active, #breadcrumbs-option-3.active');
    if (reviewHasContent(review, runtime) && reviewStep) {
      onEvent('review_page', {
        stone: stateStoneFromDocument(runtime),
        setting: settingFromLocation(runtime)
      });
    }
  }

  function stateStoneFromDocument(runtime) {
    try {
      var selected = safeQuery(runtime, '[data-selected-diamond-product]');
      return parseStoneText(selected && (selected.textContent || selected.innerHTML));
    } catch (ignore) {
      return {};
    }
  }

  function handleCustomVariant(runtime, event, onEvent, state) {
    var params = filtersFromSearch((runtime.location && runtime.location.search) || '');
    if (params.diamondFirstFlowRingSelected !== 'true' && params.is_diamond_selected !== 'true') return;
    var variant = event && event.detail && event.detail.variant;
    if (!variant) return;
    var setting = {
      product_id: variant.product_id || variant.productId,
      variant_id: variant.id,
      ring_size: variant.ring_size || variant.ringSize
    };
    state.currentSetting = setting;
    onEvent('setting_selected', { setting: setting });
  }

  // The RC bundle may define its global after this script runs. An accessor
  // wraps it the moment it is assigned, so no filter change is missed while the
  // poll below is still waiting.
  function installDiamondAccessor(runtime, onEvent, state) {
    try {
      if (!runtime || Object.prototype.hasOwnProperty.call(runtime, 'NATURAL_LB_GROWN_DIAMOND')) return false;
      var stored;
      Object.defineProperty(runtime, 'NATURAL_LB_GROWN_DIAMOND', {
        configurable: true,
        enumerable: true,
        get: function () { return stored; },
        set: function (value) {
          stored = value;
          try { wrapDiamondMethods(value, onEvent, state); } catch (ignoreWrap) {}
        }
      });
      return true;
    } catch (ignore) {
      return false;
    }
  }

  function installDiamondPoll(runtime, onEvent, state) {
    var attempts = 0;
    var timer;
    function tryWrap() {
      attempts++;
      if (wrapDiamondMethods(runtime.NATURAL_LB_GROWN_DIAMOND, onEvent, state)) {
        if (timer !== undefined && runtime.clearInterval) runtime.clearInterval(timer);
        return true;
      }
      if (attempts >= 50 && timer !== undefined && runtime.clearInterval) runtime.clearInterval(timer);
      return false;
    }
    if (tryWrap()) return null;
    installDiamondAccessor(runtime, onEvent, state);
    timer = runtime.setInterval(tryWrap, 100);
    return timer;
  }

  function settingFilterSnapshot(runtime) {
    return filtersFromSearch((runtime && runtime.location && runtime.location.search) || '');
  }

  function markSettingFilterEmitted(state) {
    if (state) state.settingFilterEmittedAt = Date.now();
  }

  // A production filter click emits from the delegated listener and then calls
  // filterAllProducts in the same tick; only the first of the pair is reported.
  function consumeSettingFilterEmission(state) {
    if (!state || state.settingFilterEmittedAt === undefined || state.settingFilterEmittedAt === null) return false;
    var recent = Date.now() - state.settingFilterEmittedAt < 400;
    state.settingFilterEmittedAt = null;
    return recent;
  }

  function installFilterAllProductsWrapper(runtime, onEvent, state) {
    if (!runtime) return null;

    function wrap(original) {
      if (typeof original !== 'function' || original.__gsJourneyWrapped) return original;
      var wrapped = function () {
        try {
          return original.apply(this, arguments);
        } finally {
          if (!consumeSettingFilterEmission(state)) {
            onEvent('setting_filter_change', { filters: settingFilterSnapshot(runtime) });
          }
        }
      };
      wrapped.__gsJourneyWrapped = true;
      wrapped.__gsJourneyOriginal = original;
      return wrapped;
    }

    if (typeof runtime.filterAllProducts === 'function') {
      if (runtime.filterAllProducts.__gsJourneyWrapped) return runtime.filterAllProducts;
      try {
        runtime.filterAllProducts = wrap(runtime.filterAllProducts);
      } catch (ignoreAssign) {}
      return runtime.filterAllProducts;
    }

    try {
      if (Object.prototype.hasOwnProperty.call(runtime, 'filterAllProducts')) return null;
      var stored;
      Object.defineProperty(runtime, 'filterAllProducts', {
        configurable: true,
        enumerable: true,
        get: function () { return stored; },
        set: function (value) { stored = wrap(value); }
      });
    } catch (ignore) {}
    return null;
  }

  function installSettingObserver(runtime, onEvent) {
    if (!runtime.MutationObserver || !runtime.document) return null;
    var ring = safeQuery(runtime, '#vdb-ring-collection');
    if (!ring) return null;
    var done = false;
    var observer;
    function completeIfPopulated() {
      if (!done && ((ring.children && ring.children.length) || ring.innerHTML)) {
        done = true;
        emitInitialPageEvents(runtime, onEvent);
        observer.disconnect();
      }
    }
    observer = new runtime.MutationObserver(completeIfPopulated);
    try {
      observer.observe(ring, { childList: true, subtree: true });
    } catch (ignoreObserve) {}
    completeIfPopulated();
    return observer;
  }

  function start(runtime) {
    runtime = runtime || root;
    if (!runtime.document) return null;
    if (runtime.__GS_JOURNEY_TRACKING__) return runtime.__GS_JOURNEY_TRACKING__;
    try {
      if (runtime.document.documentElement.dataset.gsJourneyTracking === '1') return null;
    } catch (ignoreExistingDataset) {}
    var config = runtime.GS_JOURNEY_TRACKING_CONFIG || {};
    var tracker = createTracker(runtime, config);
    var state = {
      pendingStoneSelection: null,
      pendingRcAtc: null,
      resetPending: false,
      currentSetting: settingFromLocation(runtime)
    };
    var dedupe;
    try { dedupe = createDedupe(runtime.sessionStorage); } catch (ignoreStorage) { dedupe = createDedupe(null); }
    var pageNonce = uuidv4(runtime);
    var onEvent = createEventSink(tracker, dedupe, Date.now, pageNonce);
    var publicState = {
      track: tracker.track,
      flowToken: tracker.flowToken,
      pageNonce: pageNonce,
      state: state,
      onEvent: onEvent
    };
    runtime.__GS_JOURNEY_TRACKING__ = publicState;
    try {
      runtime.document.documentElement.dataset.gsJourneyTracking = '1';
    } catch (ignoreDataset) {}

    installFetchInterceptor(runtime, onEvent, state);
    installXhrInterceptor(runtime, onEvent, state);
    installDiamondPoll(runtime, onEvent, state);
    installFilterAllProductsWrapper(runtime, onEvent, state);
    installSettingObserver(runtime, onEvent);
    try {
      runtime.document.addEventListener('click', function (event) {
        handleDelegatedClick(runtime, event, onEvent, state, dedupe);
      }, true);
      runtime.addEventListener && runtime.addEventListener('custom-variant-change', function (event) {
        handleCustomVariant(runtime, event, onEvent, state);
      });
      runtime.document.addEventListener('shopify:section:load', function () {
        wrapDiamondMethods(runtime.NATURAL_LB_GROWN_DIAMOND, onEvent, state);
        emitInitialPageEvents(runtime, onEvent);
      });
    } catch (ignoreEvents) {}
    emitInitialPageEvents(runtime, onEvent);
    return publicState;
  }

  function shouldSkipUrl(url) {
    return String(url).indexOf('event-logs.php') !== -1;
  }

  function pageTypeFromContext(ctx) {
    ctx = ctx || {};
    var path = ctx.path || '';
    if (ctx.hasReview) return 'review';
    if (ctx.isDiamondPdp || isDiamondPdpPath(path)) return 'stone_pdp';
    if (isDiamondCollectionPath(path) || ctx.hasLiveStoneList) return 'stone_list';
    path = canonicalPath(path);
    if (ctx.hasRingCollection || path.indexOf('/collections/all-custom') === 0) return 'setting_list';
    if (ctx.isSettingPdp) return 'setting_pdp';
    if (/\/collections\/(.*engagement|.*-cut-engagement-ring)/.test(path)) return 'setting_list';
    return 'other';
  }

  function buildEnvelope(opts) {
    var extra = (opts && opts.extra) || {};
    var out = { schema_version: 1 };
    Object.keys(extra).forEach(function (k) {
      if (extra[k] !== undefined && extra[k] !== null && extra[k] !== '') {
        out[k] = extra[k];
      }
    });
    return out;
  }

  var api = {
    ALLOWED_EVENTS: ALLOWED_EVENTS,
    uuidv4: uuidv4,
    canonicalPath: canonicalPath,
    readFlowToken: readFlowToken,
    ensureFlowToken: ensureFlowToken,
    requestBodyToObject: requestBodyToObject,
    flowFromContext: flowFromContext,
    diamondTypeFromContext: diamondTypeFromContext,
    diamondTypeFromRuntime: diamondTypeFromRuntime,
    filtersFromSearch: filtersFromSearch,
    createDedupe: createDedupe,
    customerFromContext: customerFromContext,
    runtimePageType: runtimePageType,
    createTracker: createTracker,
    installFetchInterceptor: installFetchInterceptor,
    installXhrInterceptor: installXhrInterceptor,
    wrapDiamondMethods: wrapDiamondMethods,
    handleDelegatedClick: handleDelegatedClick,
    createEventSink: createEventSink,
    emitInitialPageEvents: emitInitialPageEvents,
    handleCustomVariant: handleCustomVariant,
    installDiamondPoll: installDiamondPoll,
    installFilterAllProductsWrapper: installFilterAllProductsWrapper,
    installSettingObserver: installSettingObserver,
    start: start,
    track: function (eventType, jsonData, error) {
      var instance = start(root);
      return instance ? instance.track(eventType, jsonData, error) : false;
    },
    shouldSkipUrl: shouldSkipUrl,
    pageTypeFromContext: pageTypeFromContext,
    buildEnvelope: buildEnvelope
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }
  root.GsJourneyTracking = api;
  if (root.document) {
    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', function () { api.start(); });
    } else {
      api.start();
    }
  }
})(typeof window !== 'undefined' ? window : global);
